module.exports = __webpack_public_path__ + "img/DIMA_MOCKUPS_TOP1.jpg";